import type { IconData } from '@stacksjs/iconify-core'

export const pacmanRemix: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M6.752 24c0-10.768 8.737-19.5 19.518-19.5a19.48 19.48 0 0 1 14.857 6.853c.1.117.136.251.103.417a.85.85 0 0 1-.384.536l-13.722 8.775c-2.132 1.363-2.132 4.476 0 5.839l13.722 8.775a.85.85 0 0 1 .385.535a.46.46 0 0 1-.104.418a19.48 19.48 0 0 1-14.857 6.853C15.49 43.5 6.752 34.768 6.752 24M26.27.5C13.283.5 2.752 11.02 2.752 24S13.283 47.5 26.27 47.5c7.167 0 13.587-3.206 17.898-8.255c1.962-2.298 1.056-5.498-1.168-6.92L29.983 24L43 15.676c2.224-1.423 3.13-4.623 1.168-6.92A23.47 23.47 0 0 0 26.271.5m-3.422 15.684a2.445 2.445 0 1 0-2.446-2.444a2.445 2.445 0 0 0 2.446 2.444\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default pacmanRemix
